import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box, CircularProgress, Alert } from '@mui/material';
import { Trash2 } from 'lucide-react';

const DeleteModal = ({ open, onClose, onDelete, title, description, error, loading }) => {
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{
            sx: {
                borderRadius: '16px', padding: '16px', width: '100%',
                maxWidth: '400px'
            }
        }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 2 }}>
                <Box
                    sx={{
                        backgroundColor: '#FEE2E2',
                        borderRadius: '50%',
                        padding: '12px',
                        marginBottom: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Trash2 size={32} color="#DC2626" />
                </Box>
                <DialogTitle sx={{ p: 0, mb: 1 }}>
                    <Typography variant="h6" fontWeight="600" color="#111827">
                        {title || "Delete Item"}
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ p: 0, mb: 2 }}>
                    <DialogContentText sx={{ color: '#6B7280', fontSize: '0.95rem' }}>
                        {description || "Are you sure you want to delete this item? This action cannot be undone."}
                    </DialogContentText>
                </DialogContent>

                {error && (
                    <Alert severity="error" sx={{ mb: 3, width: '100%', borderRadius: '8px', fontSize: '0.875rem' }}>
                        {error}
                    </Alert>
                )}
            </Box>
            <DialogActions sx={{ p: 0, display: 'flex', gap: 2, justifyContent: 'center' }}>
                <Button disableElevation disableFocusRipple disableRipple disableTouchRipple
                    onClick={onClose} variant="outlined"
                    disabled={loading}
                    sx={{
                        borderColor: '#E5E7EB', color: '#374151', borderRadius: '8px', textTransform: 'none',
                        fontWeight: 500, px: 3, py: 1,
                    }}
                >
                    Cancel
                </Button>
                <Button disableElevation disableFocusRipple disableRipple disableTouchRipple
                    onClick={onDelete} variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: '#DC2626', color: 'white', borderRadius: '8px', textTransform: 'none',
                        fontWeight: 500, px: 3, py: 1, boxShadow: 'none',
                    }}
                >
                    {loading ? <CircularProgress size={20} color="inherit" /> : "Delete"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteModal;
